module.exports = __webpack_public_path__ + "media/images/front/medical_leaders/top/img_result08-5b252449ad0b6be1c6bb25fb0ced4010.png";